/**
 * Purchase Summary Report API Service
 * @see Sprint 32 - Rapport Sommaire des Achats
 * @see US-32.3 - Frontend Page et Composants
 */

import { apiClient } from '@/api/client';
import type {
  PurchaseSummaryReportData,
  PurchaseSummaryReportQuery,
} from '@bstock/shared';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

/**
 * Get purchase summary report for a period
 */
export async function getPurchaseSummaryReport(
  params: PurchaseSummaryReportQuery
): Promise<PurchaseSummaryReportData> {
  const response = await apiClient.get<ApiResponse<PurchaseSummaryReportData>>(
    '/reports/purchase-summary',
    { params }
  );
  return response.data.data;
}
